import { render, staticRenderFns } from "./preach.vue?vue&type=template&id=0aa41236"
import script from "./preach.vue?vue&type=script&lang=ts"
export * from "./preach.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports